<template>
    <Breadcrumbs main="Gallery" title="Gallery Grid With Description" />
    <div class="container-fluid">
        <div class="row">
            <gridDesc />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const gridDesc = defineAsyncComponent(() => import("@/components/theme/gallery/grid/gridDesc.vue"))
</script>